import { CART_DISCOUNT } from '~~/constants/cartDiscounts';
import { getDiscountPercentage } from '~~/helpers/discounts/cartDiscountFields';
import { getDistinctProductsMinimalCount } from '~~/helpers/discounts/getDistinctProductsMinimalCount';
import type { DistinctProductsDiscount } from '~~/types/discounts';

/**
 * Reads the configuration of the "buy x different products" cart discount out
 * of the cart discounts loaded by `useCartDiscountsStore`. Both the percentage
 * and the amount of distinct products needed come from commercetools, so
 * markets can change them without a release.
 */
export const useDistinctProductsDiscount = () => {

  const { getCartDiscount } = useCartDiscountsStore();

  const distinctProductsDiscount = computed<DistinctProductsDiscount | null>(() => {

    const rawDiscount = getCartDiscount(CART_DISCOUNT.DISTINCT_PRODUCTS);

    if (!rawDiscount) {

      return null;

    }

    const discountPercentage = getDiscountPercentage(rawDiscount);
    const minimalQuantity = getDistinctProductsMinimalCount(rawDiscount);

    if (!discountPercentage || !minimalQuantity) {

      return null;

    }

    return { discountPercentage, minimalQuantity };

  });

  const isDistinctProductsDiscountAvailable = computed(() => !!distinctProductsDiscount.value);

  return {
    distinctProductsDiscount,
    isDistinctProductsDiscountAvailable,
  };

};
